/* eslint semi:0 */
import React from 'react'


const blockName = 'no-upcoming-matches'

export default function NoUpcomingMatches({ message, }){
  return (
    <div className={ blockName } data-message={ message } />
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/noUpcomingMatches.js